var stepperThemeWeb = {
  color: 'primary',
  align: 'center',
  connector: {
    inactiveColor: 'border.inactive',
    transparentColor: 'border.desaturated'
  },
  header: {
    activeColor: 'text',
    inactiveColor: 'text',
    transparentColor: 'text.desaturated'
  },
  transparent: {
    color: 'text.desaturated',
    inactiveOpacity: 0.4
  },
  step: {
    transparent: {
      backgroundColor: 'transparent',
      borderColor: 'border.desaturated',
      textColor: 'text.desaturated'
    },
    invalid: {
      backgroundColor: 'background',
      textColor: 'text',
      borderColor: 'border.inactive'
    },
    active: {
      backgroundColor: 'primary',
      borderColor: 'primary',
      textColor: 'background'
    },
    valid: {
      backgroundColor: 'background',
      borderColor: 'primary',
      textColor: 'primary'
    }
  }
};
var stepperThemeNative = {
  color: 'primary',
  align: 'center',
  connector: {
    inactiveColor: 'border.inactive'
  },
  header: {
    activeColor: 'text',
    inactiveColor: 'text',
    transparentColor: 'text.desaturated'
  },
  transparent: {
    color: 'text.desaturated',
    inactiveOpacity: 0.4
  },
  step: {
    transparent: {
      backgroundColor: 'transparent',
      borderColor: 'border.desaturated',
      textColor: 'text.desaturated'
    },
    invalid: {
      backgroundColor: 'background',
      textColor: 'text',
      borderColor: 'border.inactive'
    },
    active: {
      backgroundColor: 'primary',
      borderColor: 'primary',
      textColor: 'background'
    },
    valid: {
      backgroundColor: 'background',
      borderColor: 'primary',
      textColor: 'primary'
    }
  }
};

export { stepperThemeNative, stepperThemeWeb };
